import _ from "lodash";
import { convertStatusConstantToScormStatus } from "../utils/StatusUtils";
import * as StatusConstants from "../constants/StatusConstants";
import * as StoreUtils from "../utils/StoreUtils";
import * as MockScormConstants from "./Scorm2004Constants";

const getConfigObject = () => {
	const config = StoreUtils.getReducer("config");
	return config.item;
};

export default class LocalStorage {
	save(name, domain, data) {
		this.setData(name, domain, data);
	}

	restore(name, domain, restoreFunction) {
		const data = this.getData(domain);
		const restoredData = restoreFunction(data[name]);
	}

	getData(domain) {
		const data = window.localStorage.getItem(`${domain}_data`);
		const pData = JSON.parse(data);
		return (data && JSON.parse(data)) || {};
	}

	setData(name, domain, data) {
		const oldData = this.getData(domain);
		const newData = Object.assign({}, oldData, { [name]: data });
		window.localStorage.setItem(`${domain}_data`, JSON.stringify(newData));
	}

	clearData(domain) {
		console.log("LocalStorage: clearData()");
		localStorage.removeItem(`${domain}_data`);
	}

	setCourseStatus(domain, value) {
		console.log("LocalStorage: setCourseStatus", value);

		localStorage.setItem(`${domain}-course-status`, value);

		if (
			value === StatusConstants.COMPLETED ||
			value === convertStatusConstantToScormStatus(StatusConstants.COMPLETED)
		) {
			console.log(
				"LocalStorage: course is completed and success_status is therefore set to passed"
			);
			localStorage.setItem(
				`${domain}-success-status`,
				convertStatusConstantToScormStatus(StatusConstants.PASSED)
			);
		} else {
			console.log(
				"LocalStorage: course is not completed and success_status is therefore set to failed"
			);
			localStorage.setItem(
				`${domain}-success-status`,
				convertStatusConstantToScormStatus(StatusConstants.PASSED)
			);
		}
	}

	getCourseStatus(domain) {
		const value = localStorage.getItem(`${domain}-course-status`);
		console.log("LocalStorage: getCourseStatus", value);
		return value;
	}

	setCompletionStatus(domain, value) {
		console.log(
			`LocalStorage: setCompletionStatus: Setting completion status with value:`,
			value
		);
		localStorage.setItem(`${domain}-completion-status`, value);
	}

	getCompletionStatus(domain) {
		console.log(
			`LocalStorage: getCompletionStatus: Getting completion status'. Value:`,
			value
		);
		return localStorage.getItem(`${domain}-completion-status`);
	}

	setSuccessStatus(domain, value) {
		console.log(
			`LocalStorage: setSuccessStatus: Setting success status with value:`,
			value
		);
		localStorage.setItem(`${domain}-success-status`, value);
	}

	getSuccessStatus(domain) {
		console.log(
			`LocalStorage: getSuccessStatus: Getting success status'. Value:`,
			value
		);
		return localStorage.getItem(`${domain}-success-status`);
	}

	setScore(domain, rawScore, minScore, maxScore) {
		console.log("LocalStorage: setScore", rawScore, minScore, maxScore);
		localStorage.setItem(`${domain}-score-raw`, rawScore);
		localStorage.setItem(`${domain}-score-min`, minScore);
		localStorage.setItem(`${domain}-score-max`, maxScore);
		localStorage.setItem(
			`${domain}-score-scaled`,
			(rawScore / maxScore).toFixed(2)
		);
	}

	getScore(domain) {
		var value = localStorage.getItem(`${domain}-score-raw`);
		console.log("LocalStorage: getScore", value);
		return value;
	}

	getUserName(domain) {
		var userName = localStorage.getItem(`${domain}-user-name`);
		console.log(`LocalStorage: getUserName(). User name:`, userName);
		return userName;
	}

	getUserId(domain) {
		var userId = localStorage.getItem(`${domain}-user-id`);
		console.log(`LocalStorage: getUserId(). User ID:`, userId);
		return userId;
	}

	getQuiddityTitleId() {
		const config = getConfigObject();
		const quiddityTitleId = _.get(
			config,
			["lms", MockScormConstants.QUIDDITY_TITLE_ID],
			"no title id found"
		);
		console.log(
			`LocalStorage: getQuiddityTitleId(). Quiddity Title ID:`,
			quiddityTitleId
		);
		return quiddityTitleId;
	}
	getQuiddityTitleOrganizationId() {
		const config = getConfigObject();
		const quiddityTitleOrganizationId = _.get(
			config,
			["lms", MockScormConstants.QUIDDITY_TITLE_ORGANIZATION_ID],
			"no title organization id found"
		);
		console.log(
			`LocalStorage: getQuiddityTitleOrganizationId(). Quiddity Title Organization ID:`,
			quiddityTitleOrganizationId
		);
		return quiddityTitleOrganizationId;
	}

	getQuiddityTitleName() {
		const config = getConfigObject();
		const quiddityTitleName = _.get(
			config,
			["lms", MockScormConstants.QUIDDITY_TITLE_NAME],
			"no title name found"
		);
		console.log(
			`LocalStorage: getQuiddityTitleName(). Quiddity Title name:`,
			quiddityTitleName
		);
		return quiddityTitleName;
	}
}
